import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Tag, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuditLog } from '@/hooks/useAudit';

const { Title } = Typography;

const AuditDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: auditLog, isLoading } = useAuditLog(id || '');

  if (isLoading) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }} />;
  }

  if (!auditLog) {
    return <div>Registro não encontrado</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/audit')} />
          <Title level={4} style={{ margin: 0 }}>Detalhes da Auditoria</Title>
        </Space>
      </div>

      <Card>
        <Descriptions bordered column={{ xs: 1, sm: 2, lg: 3 }}>
          <Descriptions.Item label="Usuário">{auditLog.user_name || '-'}</Descriptions.Item>
          <Descriptions.Item label="Empresa">{auditLog.company_name || '-'}</Descriptions.Item>
          <Descriptions.Item label="Data/Hora">
            {new Date(auditLog.created_at).toLocaleString('pt-BR')}
          </Descriptions.Item>
          <Descriptions.Item label="Ação">
            <Tag color={
              auditLog.action === 'CREATE' ? 'green' :
              auditLog.action === 'UPDATE' ? 'blue' :
              auditLog.action === 'DELETE' ? 'red' :
              auditLog.action === 'LOGIN' ? 'purple' :
              auditLog.action === 'LOGOUT' ? 'orange' : 'default'
            }>
              {auditLog.action === 'CREATE' ? 'Criação' :
               auditLog.action === 'UPDATE' ? 'Atualização' :
               auditLog.action === 'DELETE' ? 'Exclusão' :
               auditLog.action === 'LOGIN' ? 'Login' :
               auditLog.action === 'LOGOUT' ? 'Logout' : auditLog.action}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Recurso">
            <Tag>
              {auditLog.resource_type === 'USER' ? 'Usuário' :
               auditLog.resource_type === 'COMPANY' ? 'Empresa' :
               auditLog.resource_type === 'DEVICE' ? 'Dispositivo' :
               auditLog.resource_type === 'SESSION' ? 'Sessão' : 'Sistema'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="ID do Recurso">{auditLog.resource_id || '-'}</Descriptions.Item>
          <Descriptions.Item label="Descrição" span={2}>{auditLog.description}</Descriptions.Item>
          <Descriptions.Item label="IP">{auditLog.ip_address}</Descriptions.Item>
          <Descriptions.Item label="User Agent" span={2}>{auditLog.user_agent || '-'}</Descriptions.Item>
          <Descriptions.Item label="Valor Anterior" span={3}>
            {auditLog.old_value ? JSON.stringify(auditLog.old_value, null, 2) : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Novo Valor" span={3}>
            {auditLog.new_value ? JSON.stringify(auditLog.new_value, null, 2) : '-'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default AuditDetail;
